var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlignHorizontal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 19,
    fill: "none",
    viewBox: "0 0 18 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    className: "accent",
    fillRule: "evenodd",
    d: "M2.25 3.5c0-.41.34-.75.75-.75h12c.41 0 .75.34.75.75v12c0 .41-.34.75-.75.75H3a.75.75 0 0 1-.75-.75v-12Zm1.5.75v10.5h10.5V4.25H3.75Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.25 1.25a.75.75 0 0 1 1.5 0v16.5a.75.75 0 0 1-1.5 0V1.25Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlignHorizontal);
export default __webpack_public_path__ + "static/media/alignHorizontal.88cc7621fd724bd823867469f018896c.svg";
export { ForwardRef as ReactComponent };